import React, { memo } from "react"
import { PropTypes } from "prop-types"

const ProcessSlideNumbers = ({ lang }) => (
  <div className="btn-wrapper">
    <div className="btn-row">
      <label htmlFor={`process-number-${lang}-1`}>1</label>
      <label htmlFor={`process-number-${lang}-2`}>2</label>
      <label htmlFor={`process-number-${lang}-3`}>3</label>
    </div>
    <div className="btn-row">
      <label htmlFor={`process-number-${lang}-4`}>4</label>
      <label htmlFor={`process-number-${lang}-5`}>5</label>
      <label htmlFor={`process-number-${lang}-6`}>6</label>
    </div>
  </div>
)

ProcessSlideNumbers.propTypes = {
  lang: PropTypes.string,
}

export default memo(ProcessSlideNumbers)
